export const channelListInitialState = {
    channels: [],
    selectedChannel: null,
    isLoading: true,
    isError: false,
    isUserListOpen: false,
    isOpenChannelMembers: false,
    isCollapsable: false,
};
export const channelListReducer = (state = channelListInitialState, action) => {
    var _a, _b, _c;
    switch (action.type) {
        case "initializeChannels": {
            const sortChannels = action.channels.sort((a, b) => { var _a, _b; return (_a = b.messages[0]) === null || _a === void 0 ? void 0 : _a.date.localeCompare((_b = a.messages[0]) === null || _b === void 0 ? void 0 : _b.date); });
            return Object.assign(Object.assign({}, state), { channels: sortChannels, selectedChannel: (_a = sortChannels === null || sortChannels === void 0 ? void 0 : sortChannels[0]) !== null && _a !== void 0 ? _a : null, isLoading: false, isError: false });
        }
        case "addChannel":
            return Object.assign(Object.assign({}, state), { channels: [action.channel, ...state.channels] });
        case "selectChannel":
            return Object.assign(Object.assign({}, state), { selectedChannel: action.channel, isOpenChannelMembers: false });
        case "openUserList":
            return Object.assign(Object.assign({}, state), { isUserListOpen: true });
        case "closeUserList":
            return Object.assign(Object.assign({}, state), { isUserListOpen: false });
        case "toggleUserList":
            return Object.assign(Object.assign({}, state), { isUserListOpen: !state.isUserListOpen, isCollapsable: true });
        case "loadingFailed":
            return Object.assign(Object.assign({}, state), { isLoading: false, isError: true });
        case "openChannelMembers":
            return Object.assign(Object.assign({}, state), { isOpenChannelMembers: true });
        case "closeChannelMembers":
            return Object.assign(Object.assign({}, state), { isOpenChannelMembers: false });
        case "toggleMemberList":
            return Object.assign(Object.assign({}, state), { isOpenChannelMembers: !state.isOpenChannelMembers });
        case "leaveGroup":
            return Object.assign(Object.assign({}, state), { isOpenChannelMembers: false, channels: [
                    ...state.channels.filter((c) => { var _a; return c.id !== ((_a = state.selectedChannel) === null || _a === void 0 ? void 0 : _a.id); }),
                ], selectedChannel: (_c = (_b = state.channels) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : null });
        case "openCollapse":
            return Object.assign(Object.assign({}, state), { isCollapsable: true, isUserListOpen: false });
        case "closeCollapse":
            return Object.assign(Object.assign({}, state), { isCollapsable: false, isUserListOpen: false });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map